import { render, staticRenderFns } from "./choose-teacher.vue?vue&type=template&id=d1c6aac8&"
import script from "./choose-teacher.vue?vue&type=script&lang=js&"
export * from "./choose-teacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports